import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { Field } from "../../../../../entities/Metadata";
import CalculationFinancialsTotals, { CalculationFinancialsTotals as CalculationFinancialsTotalsHelper} from "../CalculationFinancialsTotals";
import { Program } from "../../../../../store/ProgramsListStore";

export default class BenefitTotals extends React.Component<IListViewFieldColumn<Program>> {
    public render() {
        return <CalculationFinancialsTotals {...this.props} entity={this.props.entity.calculation.benefits} />;
    }

    public static getValue(entity: Program, field: Field): number | undefined {
        return CalculationFinancialsTotalsHelper.getValue(entity.calculation.benefits, field);
    }

    public static getSearchValue(entity: Program, field: Field) {
        return BenefitTotals.getValue(entity, field);
    }
}